import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastModule } from 'primeng/toast';

export type ToastType = 'success' | 'error' | 'info' | 'warn';

export interface VaniToast {
  type: ToastType;
  title: string;
  message: string;
  id?: number; // for removal
}

@Injectable({
  providedIn: 'root'
})
export class VaniToasterService {

  private toastsSubject = new BehaviorSubject<VaniToast[]>([]);
  toasts$ = this.toastsSubject.asObservable();
  private counter = 0;
  public isAccountExpiredHandled = false;
  public toasterStatus: BehaviorSubject<ToastModule> = new BehaviorSubject<ToastModule>(null);
  public closeTrackButton: BehaviorSubject<ToastModule> = new BehaviorSubject<ToastModule>(null);

  constructor() { }

  // to show toaster
  // showToast(toast: Omit<VaniToast, 'id'>) {
  //   const id = ++this.counter;
  //   const newToast = { ...toast, id };
  //   const toasts = [...this.toastsSubject.value, newToast];
  //   this.toastsSubject.next(toasts);

  //   // Auto-remove after 4 seconds
  //   setTimeout(() => this.removeToast(id), 40000);
  // }

  notify(type, header: string, content: string ) {
    const id = ++this.counter;
    const newToast = { type:type, title:header?header:this.headerTitle(type), message:content, id:id };
    const toasts = [...this.toastsSubject.value, newToast];
    this.toastsSubject.next(toasts);
    this.isAccountExpiredHandled = true;
    // Auto-remove after 4 seconds
    setTimeout(() => this.removeToast(id), 4000);
    this.toasterStatus.next(toasts);
  }

  // to decide header title based on type
  headerTitle(type?){
    switch (type) {
      case "success":
        return 'Success!';
        break;
      case "error":
        return 'Error!';
        break;
      case "warn":
        return 'Warning';
        break;
      case "info":
        return 'Custom Alert';
        break;
      default:
        return 'Custom Alert';
        break;
    }
  }

  // to remove toaster
  removeToast(id: number) {
    const toasts = this.toastsSubject.value.filter((t) => t.id !== id);
    this.toastsSubject.next(toasts);
    this.toasterStatus.next(null);
    this.isAccountExpiredHandled = false;
  }

}
